<template>
  <Box>
    <template #handle>
      <Btn v-if="hasPermi('system:cjyw:dataSynchronization:archive')" @click="addItem()">归档</Btn>
    </template>
    <template #content>
      <div class="table_main">
        <div class="query">
          <div class="left">
            <el-form ref="query_form" :model="queryParams" label-width="80px">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="所属企业" prop="companyKeyword">
                    <el-input size="small" v-model.trim="queryParams.companyKeyword" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="省市区" prop="qy">
                      <Region :qy="queryParams.qy" @change="change" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="归档时间" prop="archiveTime">
                    <el-date-picker v-model="queryParams.archiveTime" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" size="small">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="归档状态" prop="state">
                    <el-select size="small" v-model.trim="queryParams.state" clearable>
                      <el-option v-for="item in archiveTypes" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="right">
            <Btn @click="query" round>
              <span class="btn_box">
                <i class="iconfont icon-sousuo"></i>
                <span>搜索</span>
              </span>
            </Btn>
            <Btn @click="initQuery" round>
              <span class="btn_box">
                <i class="iconfont icon-chongzhi"></i>
                <span>重置</span>
              </span>
            </Btn>
          </div>
        </div>
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :selection="true" @change="changeTableSelected" :loading="loading">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                    (pageData.page - 1) * pageData.pageSize + data.index
                }}</span>
                <span v-if="data.head.handle == 'state'">{{
                  (data.data.state == 0 ? "未归档"
                    : data.data.state == 1 ? "归档中"
                      : data.data.state == 2 ? "归档成功"
                        : data.data.state == 3 ? "归档失败" : "未知")
                }}</span>
              </div>
            </template>
          </Table>
          <el-pagination class="page" background layout="total, sizes, prev, pager, next" :total="pageData.total" :page-sizes = "[10, 20, 50, 100]"
            :current-page.sync="pageData.page" :page-size.sync="pageData.pageSize" @size-change="query" @current-change="getList">
          </el-pagination>
        </div>
      </div>
      <el-dialog :visible.sync="archiveDialog" width="30%" :close-on-click-modal="false" :before-close="dialogClose">
        <div slot="title" class="header-title">
            <span class="title-age">数据归档</span>
            <span class="title-name">
            <el-tooltip class="item" effect="dark" content="归档中的设备不会被下发命令" placement="right">
              <i class="el-icon-info" style="color: #000; margin-left:5px"></i>
            </el-tooltip>
          </span>
        </div>
        <el-form label-width="80px">
            <el-row><el-descriptions title="删除年度"/></el-row>
            <el-row>
                <el-form-item label="加工年度">
                    <el-select size="small" v-model.trim="operationParam.processingAnnual" clearable @change="changeYear">
                        <el-option v-for="item in processingAnnual" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </el-row>
            <el-row><el-descriptions title="保留数据"/></el-row>
            <el-row>
                <el-form-item label="加工日期">
                    <el-date-picker v-model="operationParam.workDate" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                        format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small" :default-value="defaultDate">
                    </el-date-picker>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="加工类型">
                    <el-select v-model="operationParam.processingType" size="small" clearable>
                        <el-option v-for="item in processingTypes" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="包号">
                    <el-col :span="11">
                        <el-input-number size="small" v-model.number="operationParam.packetCodeBegin" controls-position="right"/>
                    </el-col>
                    <el-col :span="2">
                        <div style="text-align: center"><span>至</span></div>
                    </el-col>
                    <el-col :span="11">
                        <el-input-number size="small" v-model.number="operationParam.packetCodeEnd" controls-position="right"/>
                    </el-col>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="批号">
                    <el-col :span="11">
                        <el-input size="small" v-model.number="operationParam.batchNoBegin" clearable/>
                    </el-col>
                    <el-col :span="2">
                        <div style="text-align: center"><span>至</span></div>
                    </el-col>
                    <el-col :span="11">
                        <el-input size="small" v-model.number="operationParam.batchNoEnd" clearable/>
                    </el-col>
                </el-form-item>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogClose">取 消</el-button>
          <el-button size="small" type="primary" @click="dialogCommit">确 定</el-button>
        </span>
      </el-dialog>
    </template>
  </Box>
</template>

<script>
import { archiveTypes, jglx } from "@/utils/status";
import { dataSynchronizationList, processingAnnualList, collectDataArchive } from "@/api/BusinessDataManagement";
import Region from "@/components/region";
import permMixin from "@/mixins/perm";
import moment from "moment";

export default {
  mixins: [permMixin],
  components: { Region },
  data() {
    return {
      processingTypes: jglx,
      loading: false,
      archiveTypes,
      processingAnnual: [],
      pageData: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      queryParams: {
        companyKeyword: "",
        archiveTime: [],
        qy: "",
        state: "",
      },
      tableHead: [
        {
          prop: "xh",
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "center",
        },
        {
          prop: "companycode",
          label: "企业代码",
          textAlign: "center",
        },
        {
          prop: "companyname",
          label: "企业名称",
        },
        {
          prop: "sccode",
          label: "生产线编号",
          textAlign: "center",
        },
        {
          prop: "nnc",
          label: "设备编号",
          textAlign: "center",
        },
        {
          prop: "createBy",
          label: "归档人",
          textAlign: "center",
        },
        {
          prop: "state",
          label: "归档状态",
          handle: "state",
          textAlign: "center",
        },
        {
          prop: "createTime",
          label: "归档时间",
          minWidth: 100,
          textAlign: "center",
        },
      ],
      tableSelected: [],
      archiveDialog: false,
      operationParam: {
        sbids: [],
        processingAnnual: undefined,
        workDate: [],
        processingType: undefined,
        packetCodeBegin: undefined,
        packetCodeEnd: undefined,
        batchNoBegin: undefined,
        batchNoEnd: undefined
      }
    };
  },
  computed: {
      pickerOptions() {
          const that = this
          return {
              disabledDate(time) {
                  if (that.operationParam.processingAnnual) {
                      const beginTime = moment(that.operationParam.processingAnnual + "-09-01 00:00:00").valueOf()
                      const endTime = moment((Number(that.operationParam.processingAnnual) + 1) + "-08-31 23:59:59").valueOf()
                      return time.getTime() >= endTime || time.getTime() < beginTime
                  }
                  return true
              }
          }
      },
      defaultDate() {
          const that = this
          if (that.operationParam.processingAnnual) {
              return moment(that.operationParam.processingAnnual + "-09-01").format()
          }
          return new Date()
      }
  },
  methods: {
    change(val) {
      this.queryParams.qy = val;
    },
    changeTableSelected(arr = []) {
      this.tableSelected = arr;
    },
    addItem() {
      if (!this.tableSelected.length) {
        this.$message.info("请勾选条目");
        return;
      }
      this.operationParam.sbids = this.tableSelected.map((item) => item.sbid)
      this.operationParam.processingAnnual = undefined
      this.operationParam.workDate = []
      this.operationParam.processingType = undefined
      this.operationParam.packetCodeBegin = undefined
      this.operationParam.packetCodeEnd = undefined
      this.operationParam.batchNoBegin = undefined
      this.operationParam.batchNoEnd = undefined
      this.archiveDialog = true
    },
    initQuery() {
      this.pageData.page = 1;
      this.$refs.query_form.resetFields();
    },
    dialogClose() {
      this.archiveDialog = false
    },
    dialogCommit() {
        collectDataArchive(this.operationParam).then((res) => {
          this.$message({
            message: res.msg,
            type: "success",
          })
          this.getList()
          this.dialogClose()
        }).catch((err) => {
            this.dialogClose()
        });
    },
    changeYear() {
      this.operationParam.workDate = []
    },
    query() {
      this.pageData.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true
      const params = {
        ...this.queryParams,
        currentPage: this.pageData.page,
        pageSize: this.pageData.pageSize
      };
      dataSynchronizationList(params)
        .then((res) => {
          this.pageData.total = res.data.count;
          this.tableData = res.data?.list || [];
          this.tableData.forEach((item) => {
            item.createTime = item.createTime ? moment(item.createTime).format("YYYY-MM-DD HH:mm:ss") : ''
          })
          this.loading = false
        })
        .catch((err) => {
          this.pageData.total = 0;
          this.tableData = [];
          this.loading = false
        });
    },
    getProcessingAnnualList() {
      processingAnnualList().then(res => {
        this.processingAnnual = res.data
      })
    },
  },
  created() {
    this.getList();
    this.getProcessingAnnualList()
  },
};
</script>

<style>

    .el-descriptions__title {
        font-size: 15px;
        font-weight: 600;
    }

</style>
